import { NOTIFICATION_VARIANTS } from "./bannerVariants";

export const NOTIFICATION_TYPES = {
  CONFIRM_EMAIL: "CONFIRM_EMAIL",
  PASSWORD_RESET_ERROR: "PASSWORD_RESET_ERROR",
  PASSWORD_RESET_SUCCESS: "PASSWORD_RESET_SUCCESS",
};

export const NOTIFICATIONS = {
  CONFIRM_EMAIL: {
    NAME: "confirmEmail",
    VARIANT: NOTIFICATION_VARIANTS.INFO,
    NOTIFICATION: {
      TITLE: "Your email has been verified successfully",
      TEXT: "You can log in and start using MeTime now.",
    },
  },
  PASSWORD_RESET_SUCCESS: {
    NEME: "passwordResetSuccess",
    VARIANT: NOTIFICATION_VARIANTS.INFO,
    NOTIFICATION: {
      TITLE: "Your password has been successfully reset",
      TEXT: "You can now log in with your new credentials.",
    },
  },
  PASSWORD_RESET_ERROR: {
    NAME: "passwordResetError",
    VARIANT: NOTIFICATION_VARIANTS.ERROR,
    NOTIFICATION: {
      TITLE: "You used an expired password reset link",
      CONTENT: "PASSWORD_RESET_ERROR",
    },
  },
};
